module.exports = __webpack_public_path__ + "ye.cfa9a4263e904c02ed3f.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/ye.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/ye.svg
// module chunks = styles